//AadhaarDetailsSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as AadhaarDetailsAPI from "./AadhaarDetailsApi";

const initialState = {
  status: "idle",
  error: null,
  otp: "",
  isOTPVerified: false,
  aadhaarDetails: null,
};

export const checkAadhaarAsync = createAsyncThunk(
  "Aadhaar/checkAadhaar",
  async (Aadhaar) => {
    const response = await AadhaarDetailsAPI.checkAadhaar(Aadhaar);

    return response;
  }
);

export const fetchAadhaarDetailsAsync = createAsyncThunk(
  "Aadhaar/fetchAadhaarDetails",
  async (Aadhaar) => {
    const response = await AadhaarDetailsAPI.fetchAadhaarDetails(Aadhaar);
    return response;
  }
);

export const AadhaarDetailsSlice = createSlice({
  name: "Aadhaar",
  initialState,
  reducers: {
    setOTP: (state, action) => {
      state.otp = action.payload;
    },
    setOTPVerified: (state, action) => {
      state.isOTPVerified = action.payload;
    },
    resetAadhaarOTPVerified: (state, action) => {
      state.isOTPVerified = state.initialState;
    },
    clearAadhaarDetails: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkAadhaarAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkAadhaarAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.otp = action.payload.otp;
        console.log("otpINSLICE:", action.payload.otp);
      })
      .addCase(checkAadhaarAsync.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      })
      .addCase(fetchAadhaarDetailsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAadhaarDetailsAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.aadhaarDetails = action.payload;
      })
      .addCase(fetchAadhaarDetailsAsync.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  },
});

export const {
  setOTP,
  setOTPVerified,
  clearAadhaarDetails,
  resetAadhaarOTPVerified,
} = AadhaarDetailsSlice.actions;
// Selector to get OTP from state
export const selectOTP = (state) => state.Aadhaar.otp;

export const selectIsOTPVerified = (state) => state.Aadhaar.isOTPVerified;
export const selectAadhaarDetails = (state) => state.Aadhaar.aadhaarDetails;

export default AadhaarDetailsSlice.reducer;
